import React, {useState, useLayoutEffect} from 'react';
import '../node_modules/rc-slider/assets/index.css';
import './flexboxgrid.css';
import './App.css';
import WorkLoadType from './components/WorkLoadType';
import ToolResults from '../src/components/ToolResults';
import bandwidthStore from './store/bandwidth';
import { text } from './messages/codeMessages';

function App() {

  const [state, setState] = useState({active: 'bandwidth'});
  const [bandwidthState, setBandwidthState] = useState(bandwidthStore.initialState);
  useLayoutEffect(()=> {
    const subs = bandwidthStore.subscribe(setBandwidthState);
    bandwidthStore.init();

    return () => subs.unsubscribe();
  },[]);

  const content = {
    bandwidth: <ToolResults id= 'bandwidth' state={bandwidthState} />,
    block: <ToolResults id='block' state={bandwidthState}/>,
    hpc: <ToolResults id='hpc' state={bandwidthState}/>,
    own: <ToolResults id='own' state={bandwidthState}/>,
  } 
  
  return (

    <div className="App">
      <div className="row">
        <div className="brandingBar col-xs-12">
            <a href="http://www.oracle.com">
                <div className="oLogo"></div>
            </a>
            <span>Cloud Infrastructure Estimator</span>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 title">
          <h1 className="titleFont">
            {text.title}
          </h1>
        </div>
      </div>
      <div className="row ">
        <div className="col-xs-12 title">
          <h3 className="titleSubFont">
            {text.subTitle}
          </h3>
        </div>
      </div>

      <div className="row between-md infoCardContainer">
        <WorkLoadType
          id = "bandwidth"
          title = {text.bandwidth.title}
          savings = {text.bandwidth.savings}
          info = {text.bandwidth.body}
          state = {bandwidthState}
          onClick={active => setState({active})}
        />
        <WorkLoadType
          id = "block"
          title = {text.blockStorage.title}
          savings = {text.blockStorage.savings}
          info = {text.blockStorage.body}
          state = {bandwidthState}
          onClick={active => setState({active})}
        />
        <WorkLoadType
          id = "hpc"
          title = {text.hpc.title}
          savings = {text.hpc.savings}
          info = {text.hpc.body}
          state = {bandwidthState}
          onClick={active => setState({active})}
        />
        <WorkLoadType
          id = "own"
          title={text.own.title}
          savings = {text.own.savings}
          info={text.own.body}
          state = {bandwidthState}
          onClick={active => setState({active})}
        />
      </div>

      <div className="whiteBodyContainer">
        {content[state.active]}
      </div>
    </div>
  );
}

export default App;
